import { useCallback } from 'react';
import { isFunc, isObject } from "../utils/type";

function useRefSetter(targetRef) {
  return useCallback(function (refValue) {
    if (isFunc(targetRef)) {
      targetRef(isObject(refValue) && Object.prototype.hasOwnProperty.call(refValue, 'view') ? refValue.view : refValue); // eslint-disable-next-line no-prototype-builtins
    } else if (isObject(targetRef) && targetRef !== null && targetRef !== void 0 && targetRef.hasOwnProperty('current')) {
      // eslint-disable-next-line no-param-reassign
      targetRef.current = refValue;
    }
  }, [targetRef]);
}

export default useRefSetter;